/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { v4 as uuidv4 } from 'uuid';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _indexOf from 'lodash/indexOf';
import {
  getSpan,
  getTypeNameBySpan
} from '../../../components/Visualizer/utils';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export default (set, get, metadata, bundleChoiceId, bundleDesign, zone) => set(
  produce(
    get(),
    (draft) => {
      if (!draft.design) {
        draft.design = {};
      }

      const { products = [] } = draft?.bundles?.data?.[bundleDesign];
      const bundleId = uuidv4();
      const [row, col] = zone;

      const enhancedBundleProducts = _map(products, (product, productIndex) => {
        const {
          choiceId,
          sku,
          origin: { Height: height }
        } = product;
        const {
          GridSpan: gridSpan,
          ProductType: productType,
        } = metadata[product.choiceId].metadata;
        const span = getSpan(gridSpan);
        const [, spanCol] = span;

        const prevProduct = products?.[productIndex - 1];
        const prevProductMetadata = metadata?.[prevProduct?.choiceId]?.metadata;
        const [, prevColSpan] = prevProductMetadata
          ? getSpan(prevProductMetadata?.GridSpan)
          : [null, null, null];

        return ({
          choiceId,
          Origin: (prevColSpan === 2 && spanCol === 2)
            ? [row, spanCol, height]
            : [row, col, height],
          Sku: sku,
          stackItemId: uuidv4(),
          type: productType === 'Base' ? 'Base' : getTypeNameBySpan(span),
          choiceBundle: {
            id: bundleId,
            choiceId: bundleChoiceId
          }
        });
      });

      const addedBundleProducts = _map(products, () => ({
        bundleId,
        bundleChoiceId
      }));

      // update state
      draft.bundles.added.push(...addedBundleProducts);
      draft.design.products.push(...enhancedBundleProducts);
      draft.design.selectedProduct = null;

      // logging
      logNewRelicCustom(NEW_RELIC_EVENTS.BUNDLE_PRODUCT_ADDED, { bundleChoiceId, bundleDesign });
    }),
  false,
  { type: 'BUNDLE ADD', payload: { bundleDesign, bundleChoiceId } }
);
